import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VTextField, _vm._g(_vm._b({
    attrs: {
      "type": _vm.isContentHidden ? 'password' : 'text',
      "append-icon": _vm.isContentHidden ? 'fal fa-eye-slash' : 'fal fa-eye'
    },
    on: {
      "click:append": function ($event) {
        _vm.isContentHidden = !_vm.isContentHidden;
      }
    }
  }, 'v-text-field', {
    ..._vm.commonAttrs,
    ..._vm.$attrs
  }, false), _vm.$listeners));
};
var staticRenderFns = [];
export { render, staticRenderFns };